/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_TitleInputs */

const en_live_caption_title = /** @type {(inputs: Live_Caption_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Captioning`)
};

const fr_live_caption_title = /** @type {(inputs: Live_Caption_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titrage en direct`)
};

const de_live_caption_title = /** @type {(inputs: Live_Caption_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Untertitelung`)
};

const it_live_caption_title = /** @type {(inputs: Live_Caption_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli in diretta`)
};

const ru_live_caption_title = /** @type {(inputs: Live_Caption_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры в реальном времени`)
};

const es_live_caption_title = /** @type {(inputs: Live_Caption_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitulado en directo`)
};

const zh_cn2_live_caption_title = /** @type {(inputs: Live_Caption_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时字幕`)
};

const ja_live_caption_title = /** @type {(inputs: Live_Caption_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブキャプション`)
};

const hi_live_caption_title = /** @type {(inputs: Live_Caption_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव कैप्शनिंग`)
};

const pt_pt2_live_caption_title = /** @type {(inputs: Live_Caption_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas ao vivo`)
};

/**
* | output |
* | --- |
* | "Live Captioning" |
*
* @param {Live_Caption_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_title = /** @type {((inputs?: Live_Caption_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_title(inputs)
	if (locale === "de") return de_live_caption_title(inputs)
	if (locale === "it") return it_live_caption_title(inputs)
	if (locale === "ru") return ru_live_caption_title(inputs)
	if (locale === "es") return es_live_caption_title(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_title(inputs)
	if (locale === "ja") return ja_live_caption_title(inputs)
	if (locale === "hi") return hi_live_caption_title(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_title(inputs)
	return en_live_caption_title(inputs)
});